/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import _ from 'lodash';

import * as actionTypes from './ActionTypes';

const axiosPayLoad = {};

// reducer handling function
const reducer = (state = axiosPayLoad, action) => {
  switch (action.type) {
    case actionTypes.SEARCH_CMS_DRUG_TAB_DATA:
      return {
        ...state,
        searchCmsDrugObj: action.searchCmsDrugObj,
      };
    case actionTypes.CMS_DRUG_DETAIL_TAB_DATA:
      return {
        ...state,
        cmsDrugDetailObj: action.cmsDrugDetailObj,
      };

    case actionTypes.GET_MANUFACTURER_DATA_DFD:
      return {
        ...state,
        manufacturerList: action.manufacturerList,
      };
    case actionTypes.GET_AUDIT_TYPE_DFD:
      return {
        ...state,
        auditTypeList: action.auditTypeList,
      };

    case actionTypes.GET_CMS_DRUG_BY_CRITERIA:
      return {
        ...state,
        searchDrugByCriteriaList: action.searchDrugByCriteriaList,
      };

    case actionTypes.HANDLE_ERROR_MESSAGE_FOR_DFD:
      return { ...state, errorMessagesInRedux: action.errorMessagesInRedux };

    case actionTypes.UPDATE_AUDIT_CLEARED_INDEX_DATA_DFD:
      return {
        ...state,
        auditClearedIndexData: action.auditClearedIndexData,
      };
    case actionTypes.GET_SEARCH_CMS_DRUG_BY_CRITERIA_LIST:
      return {
        ...state,
        searchCmsDrugByCriteriaList: action.searchCmsDrugByCriteriaList,
      };
    case actionTypes.PREVIOUS_DRUG_DATA_DFD:
      return {
        ...state,
        previousData: action.previousData,
      };
    case actionTypes.DETAIL_SCREEN_OBJ_DFD:
      return {
        ...state,
        detailScreenObj: action.detailScreenObj,
      };
    case actionTypes.MFG_SELECTED:
      return {
        ...state,
        mfgSelected: action.mfgSelected,
      };
      case actionTypes.SUCCESSFUL_DATA_PAYLOAD:
        return {
          ...state,
          sucessPayload: action.sucessPayload,
        };
    case actionTypes.RESET_REDUX_DFD:
      return [];

    default:
      return state;
  }
};

export default reducer;
